import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Locale, Digits, Calendar } from '@mosaferati/i18n';

interface Prefs {
  locale: Locale;
  digits: Digits;
  calendar: Calendar;
  onboarded: boolean;
  todayMap: 'satellite' | 'dark';
  setLocale: (l: Locale) => void;
  setDigits: (d: Digits) => void;
  setCalendar: (c: Calendar) => void;
  setOnboarded: (v: boolean) => void;
  setTodayMap: (v: 'satellite' | 'dark') => void;
}

/** User preferences persisted locally (also mirrored to the API in /me/settings once logged in). */
export const usePrefs = create<Prefs>()(
  persist(
    (set) => ({
      locale: 'fa',
      digits: 'fa',
      calendar: 'persian',
      onboarded: false,
      todayMap: 'satellite' as const,
      setLocale: (locale) => set({ locale, digits: locale === 'fa' ? 'fa' : 'latn', calendar: locale === 'fa' ? 'persian' : 'gregory' }),
      setDigits: (digits) => set({ digits }),
      setCalendar: (calendar) => set({ calendar }),
      setOnboarded: (onboarded) => set({ onboarded }),
      setTodayMap: (todayMap: 'satellite' | 'dark') => set({ todayMap }),
    }),
    { name: 'mos.prefs' },
  ),
);
